import LoginForm from '@components/login-form/LoginForm';
import { AuthContext } from 'auth/context';
import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <>
      {isAuthenticated && <Redirect to="/" />}
      <LoginForm />
    </>
  );
};

export default LoginPage;
